import { render } from "./ReservationDetailPage.vue?vue&type=template&id=1f5fa797&scoped=true&ts=true"
import script from "./ReservationDetailPage.vue?vue&type=script&lang=ts"
export * from "./ReservationDetailPage.vue?vue&type=script&lang=ts"

import "./ReservationDetailPage.vue?vue&type=style&index=0&id=1f5fa797&lang=scss&scoped=true"

import exportComponent from "D:\\Proyectos\\mytransfers-extranet-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f5fa797"]])

export default __exports__